<div class="main">
  <div class="header">
    <div class="left">
      <img src="images/aradalogo.png" alt="logo" class="header__logo" />
      <div class="header__title">Arada Group</div>
    </div>

    @if(user){
    <button class="log_out" (click)="onLogout()">Log Out</button>
    }
  </div>
</div>
